import { render, staticRenderFns } from "./ServiceProvider.vue?vue&type=template&id=6d4f2082&scoped=true&"
import script from "./ServiceProvider.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProvider.vue?vue&type=style&index=0&id=6d4f2082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f2082",
  null
  
)

export default component.exports